import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";
import { formatApiError } from "@/lib/api";
import { IMAGES as IMG } from "@/data/content";

export default function Login() {
  const { login } = useAuth();
  const { t } = useLanguage();
  const l = t.login;
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success(l.ok);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-y5-ink border border-y5-line px-4 py-3.5 text-white placeholder:text-white/30 focus:border-y5-yellow focus:outline-none transition-colors";

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <img src={IMG.fullLogo} alt="Yellow5" className="h-10 mx-auto mb-10" />
        <div className="bg-y5-surface border border-y5-line p-8">
          <div className="flex items-center gap-2 text-y5-yellow mb-2"><Lock size={16} /><span className="text-sm uppercase tracking-widest">{l.area}</span></div>
          <h1 className="font-display text-3xl mb-8">{l.title}</h1>
          <form onSubmit={submit} data-testid="login-form" className="space-y-5">
            <input type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={l.email} className={inputCls} />
            <input type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={l.password} className={inputCls} />
            <button type="submit" data-testid="login-submit" disabled={loading} className="w-full flex items-center justify-center gap-2 bg-y5-yellow text-y5-ink font-semibold py-4 hover:scale-[1.01] transition-transform disabled:opacity-60">
              {loading ? <Loader2 className="animate-spin" size={18} /> : l.submit}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
